import { ChangeDetectionStrategy, Component, computed, inject, viewChild } from '@angular/core';
import { MenuProfileComponent } from '@layout/menu-profile/menu-profile.component';
import { UserAvatarComponent } from '@layout/user-avatar/user-avatar.component';
import { CurrentUserService } from '@shared/services';
import { ButtonModule } from 'primeng/button';
import { Popover, PopoverModule } from 'primeng/popover';

@Component({
    selector: 'app-toolbar-account',
    templateUrl: './toolbar-account.component.html',
    styleUrls: ['./toolbar-account.component.scss'],
    standalone: true,
    imports: [ButtonModule, PopoverModule, UserAvatarComponent, MenuProfileComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarAccountComponent {
    private currentUserService = inject(CurrentUserService);

    currentUserShortName = computed(() => this.currentUserService.currentUser().shortName);

    readonly overlay = viewChild<Popover>('profileMenu');

    hideOverlay(): void {
        this.overlay()?.hide();
    }
}
